import React, { useState, useEffect } from "react";

import "quill/dist/quill.snow.css";

import BtnPdf from "../../Commons/Buttons/BtnPdf";
import SelectField from "../../Commons/Forms/SelectField";
import TableSpinner from "../../TableSpinner/TableSpinner";

import { useQuill } from "react-quilljs";
import { formatDate } from "../../../Assets/Helpers/Common";
import { useParams } from "react-router-dom";
import { getAssessmentHistory } from "../../Helpers/API/AssessmentApi/AssessmentApi";
import { FORM } from "../../../Constants/doctor";
import {
  getResidentDetails,
  getRole,
  getUser,
} from "../../Helpers/Utilities/Common";
import BtnPdfV2 from "../../Commons/Buttons/BtnPdfV2";

function ReferralLetterForm({ fileName }) {
  const role = getRole();
  const user = getUser();
  const details = getResidentDetails(user);
  const { id } = useParams();
  const currentDate = new Date();
  const [formPdf, setFormPdf] = useState(null);
  const [type, setType] = useState(5);
  const [typeValue, setTypeValue] = useState({
    value: 5,
    label: "Referral Letter for General Purpose",
  });
  const [selectedDoctor, setSelectedDoctor] = useState({
    value: "1",
    label: "MYT ADMIN",
    prc_no: "PTR No. 111111",
  });
  const [assessmentData, setAssessmentData] = useState(false);
  const { quill, quillRef } = useQuill();

  // formats for formTypes
  const types = {
    8: `
      <h2 style="text-align:center; font-size:18px">
      <strong>REFERRAL LETTER</strong>
      </h2>
      <br/>
      <p style="text-align:right">${formatDate(currentDate)}</p>
      <br/>
      <p>&nbsp;To:</p>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Respectfully referring to you patient <strong>${
        assessmentData?.formatted_patient_name
      }</strong>, ${assessmentData?.age?.replace(/y\/o/i, "").trim()} / ${
      assessmentData?.patient_sex
    },
        of for <strong>MEDICAL NUTRITION THERAPY</strong>.</p>
      <br/>
      <p>Diagnosis:</p>
      <strong>${generateDiagnosisBullets(
        assessmentData.diagnosis_list
      )}</strong>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; TCR:</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; kcal/day	</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; CHO:</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; CHON:</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Fats:</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Fiber:</p>
      <br/>
      <br/>
      <p style="text-align:center; font-size:18px">
      divided into &nbsp;<strong>3 SMEALS AND 3 SNACKS</strong>.
      </p>
      <p>&nbsp;Breakdown:</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Breakfast - 10%</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lunch - 30%</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dinner - 30%</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Snacks - 10% each x 3</p>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Thank you very much!</p>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <p style="text-align:right; font-size:18px">
      <strong><u>${
        role === "director" || role === "pcp" || role === "specialist"
          ? FORM.footer.doctor_name || ""
          : role === "nurse"
          ? selectedDoctor?.label || ""
          : details?.[0]?.name || ""
      }</u></strong>
      </p>
      <p style="text-align:right;">
        ${
          role === "director" || role === "pcp" || role === "specialist"
            ? FORM.footer.ptr || ""
            : role === "nurse"
            ? selectedDoctor?.prc_no || ""
            : details?.[0]?.prc_no || ""
        }
      </p>
    `,
    9: `
    <h2 style="text-align:center; font-size:18px">
    <strong>REFERRAL LETTER</strong>
    </h2>
      <br/>
      <p style="text-align:right">${formatDate(currentDate)}</p>
      <br/>
      <p>&nbsp;To:</p>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Respectfully referring to you patient <strong>${
        assessmentData?.formatted_patient_name
      }</strong>, ${assessmentData?.age?.replace(/y\/o/i, "").trim()} / ${
      assessmentData?.patient_sex
    }, 
        of for <strong>FINE-NEEDLE ASPIRATION BIOPSY</strong> of thyroid nodules..</p>
      <br/>
      <p>Impression/Diagnosis:</p>
      <strong>${generateDiagnosisBullets(
        assessmentData.diagnosis_list
      )}</strong>
      <br/>
      <br/>
      <p>Dx:</p>
      <br/>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Attached herewith are the results ot the thyroid function test and neck ultrasound.</p>
      <br/>
      <br/>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Thank you very much!</p>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <p style="text-align:right; font-size:18px">
      <strong><u>${
        // role === "admin" ?
        // FORM.footer.doctor_name
        // :
        // details[0]?.name
        role === "director" || role === "pcp" || role === "specialist"
          ? FORM.footer.doctor_name || ""
          : role === "nurse"
          ? selectedDoctor?.label || ""
          : details?.[0]?.name || ""
      }</u></strong>
      </p>
      <p style="text-align:right;">
      ${
        // role === "admin" ?
        // FORM.footer.license
        // :
        // details[0]?.license_no
        role === "director" || role === "pcp" || role === "specialist"
          ? FORM.footer.license || ""
          : role === "nurse"
          ? selectedDoctor?.license_no || ""
          : details?.[0]?.license_no || ""
      }
      </p>
      <p style="text-align:right;">
      ${
        role === "director" || role === "pcp" || role === "specialist"
          ? FORM.footer.ptr || ""
          : role === "nurse"
          ? selectedDoctor?.prc_no || ""
          : details?.[0]?.prc_no || ""
      }
      </p>
    `,
    5: `
    <h2 style="text-align:center; font-size:18px">
    <strong>REFERRAL LETTER</strong>
    </h2>
      <br/>
      <p style="text-align:right">${formatDate(currentDate)}</p>
      <br/>
      <p>&nbsp;Dear Dr.:</p>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Respectfully referring to you patient <strong>${
        assessmentData?.formatted_patient_name
      }</strong>, ${assessmentData?.age?.replace(/y\/o/i, "").trim()} / ${
      assessmentData?.patient_sex
    }, 
        of for further evaluation and management of ...</p>
      <br/>
      <p>Impressions/Diagnosis:</p>
      <strong>${generateDiagnosisBullets(
        assessmentData.diagnosis_list
      )}</strong>
      <p>Present Medications: <strong>${
        assessmentData.therapeutics
      }</strong></p>
      <br/>
      <br/>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Thank you very much!</p>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <p style="text-align:right; font-size:18px">
      <strong><u>${
        // role === "admin" ?
        // FORM.footer.doctor_name
        // :
        // details[0]?.name
        role === "director" || role === "pcp" || role === "specialist"
          ? FORM.footer.doctor_name || ""
          : role === "nurse"
          ? selectedDoctor?.label || ""
          : details?.[0]?.name || ""
      }</u></strong>
      </p>
      <p style="text-align:right;">
        ${
          role === "director" || role === "pcp" || role === "specialist"
            ? FORM.footer.ptr || ""
            : role === "nurse"
            ? selectedDoctor?.prc_no || ""
            : details?.[0]?.prc_no || ""
        }
      </p>
    `,
  };

  function generateDiagnosisBullets(diagnosisList) {
    if (!Array.isArray(diagnosisList) || diagnosisList.length === 0)
      return "N/A";

    return `
      <ul style="margin: 0; padding-left: 20px;">
        ${diagnosisList.map((d) => `<li>${d?.diagnosis_name}</li>`).join("")}
      </ul>
    `;
  }

  // TO FETCH ASSESSMENT DATA
  async function fetchData() {
    const response = await getAssessmentHistory({ patient_id: id });
    if (response.error) {
      setAssessmentData([]);
    } else {
      var assessments = response.data.data.map((data) => {
        var info = data;
        info.date = formatDate(data.added_on);
        let therapeutics = "";
        info.raw_therapeutics = data.therapeutics;
        data.therapeutics.map((data, index) => {
          return (therapeutics +=
            index +
            1 +
            ". " +
            data.generic +
            " " +
            data.brand +
            " " +
            data.preparation +
            " " +
            data.form +
            " " +
            data.frequency +
            " " +
            data.timing +
            ", ");
        });
        info.therapeutics = therapeutics;
        info.professional_fee = data.outpatients
          ? data.outpatients[0]?.professional_fee
          : "";
        info.diagnosis_list = (data.diagnosis || []).map((d) => ({
          id: d.id,
          diagnosis_name: d.diagnosis_name || "",
        }));
        return info;
      });
      setAssessmentData(assessments[0]);
    }
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (quill) {
      var quillContent = types[type];
      quill.clipboard.dangerouslyPasteHTML(quillContent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quill, type, assessmentData, selectedDoctor]);

  function handleDoctorChange(e) {
    setSelectedDoctor({
      value: e.value,
      label: e.label,
      prc_no: e.prc_no,
    });
  }

  return (
    <div>
      <div className="row">
        <div className="col-3" />
        {role !== "nurse" && ( //create space to adjust placement for type dropdown if role is not nurse
          <div className="col-4" />
        )}
        <div className="col-5 med-cert-dropsearch">
          <SelectField
            searchable
            className="dropsearch-filter"
            name="laboratory"
            size={`sm`}
            placeholder={"SELECT"}
            value={typeValue}
            options={[
              // { value: "", label: "SELECT" },
              {
                value: 8,
                label: "Referral Letter for Medical Nutrition Therapy",
              },
              {
                value: 9,
                label: "Referral Letter for Fine-Needle Aspiration Biopsy",
              },
              {
                value: 5,
                label: "Referral Letter for General Purpose",
              },
            ]}
            onChange={(e) => {
              setType(e.value);
              setTypeValue({ value: e.value, label: e.label });
            }}
          />
        </div>
        {role === "nurse" && (
          <div className="col-4 med-cert-dropsearch">
            <SelectField
              searchable
              className="dropsearch-filter mt-3"
              name="laboratory"
              size={`sm`}
              value={selectedDoctor}
              options={[
                {
                  value: "28",
                  label: "Airon May Estremos",
                  prc_no: "PRC No. 0158271",
                },
                {
                  value: "30",
                  label: "Raul Jr. J. Pales",
                  prc_no: "PRC No. 0158844",
                },
              ]}
              onChange={(e) => {
                handleDoctorChange(e);
              }}
            />
          </div>
        )}
      </div>
      {assessmentData ? (
        <>
          <div className="row p-5 pt-1 ps-3 mt-1 quill-cont mb-5 med-cert-container">
            <div
              id={`referral_letter_${type}`}
              ref={quillRef}
              className="custom-quill"
            />
          </div>
        </>
      ) : (
        <>
          <div className="row p-5 pt-1 ps-3 mt-1 quill-cont mb-5">
            <TableSpinner />
          </div>
        </>
      )}
      <div className="row justify-content-end mt-5 ">
        <div className="col-9"></div>
        <div className="col">
          <BtnPdfV2
            size={"sm"}
            divId={`referral_letter_${type}`}
            label={"Save Form"}
            fileName={fileName}
            setFormPdf={setFormPdf}
            quill={quill}
            formPdf={formPdf}
            id={id}
            typeValue={typeValue}
            paperType={"a4"}
          />
        </div>
      </div>
    </div>
  );
}
export default ReferralLetterForm;
